import { FC } from 'react';
import { useTheme, alpha } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as CheckIcon } from '../../../static/icons/ic_approved.svg';

type TPlanCard = {
  plan: {
    license: string,
    options: Array<string>,
    price: string
  }
};
const PricingPlanCard: FC<TPlanCard> = ({ plan }) => {
  const theme = useTheme();
  const {
    license, options, price,
  } = plan;

  const isLight = theme.palette.mode === 'light';

  return (
    <Card
      sx={{
        background: '#161C24',
        p: 5,
        boxShadow: (theme) => `0px 48px 80px ${alpha(isLight ? theme.palette.grey[500] : theme.palette.common.black, 0.48)}`,
      }}
    >
      <Stack spacing={5}>
        <div>
          <Typography variant="overline" sx={{ mb: 2, color: 'text.disabled', display: 'block' }}>
            PLAN
          </Typography>
          <Typography variant="h4">{license}</Typography>
          <Typography
            color="#A855F7"
            variant="body1"
          >
            {price}
          </Typography>
        </div>

        <Stack spacing={2.5}>
          {options.map((option) => (
            <Stack
              spacing={1.5}
              direction="row"
              alignItems="center"
              key={option}
            >
              <SvgIcon
                sx={{
                  width: 22,
                  height: 22,
                  color: '#A855F7',
                }}
                component={CheckIcon}
                inheritViewBox
              />
              <Typography variant="body2">{option}</Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Card>
  );
};

export { PricingPlanCard };
